import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'lib-flag-displayer',
  templateUrl: './flag-displayer.component.html',
  styleUrls: ['./flag-displayer.component.scss'],
})
export class FlagDisplayerComponent implements OnInit {
  @Input('language') language: string | undefined = ''
  @Input('multipleLanguages') multipleLanguages: string[] | undefined = []
  @Input('withLanguageText') withLanguageText: boolean = false
  @Input('center') center: boolean = false

  constructor() {}

  ngOnInit(): void {}

  getImageSource(language: string) {
    switch (language) {
      case 'en':
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg`
      case 'el':
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/GR.svg`
      case 'he':
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/IL.svg`
      case 'ja':
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/JP.svg`
      default:
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${language?.toUpperCase()}.svg`
    }
  }

  getLanguage(language: string) {
    // @ts-ignore
    return SbsLanguage[language]
  }
}

export enum SbsLanguage {
  en = 'English',
  fr = 'Français',
  de = 'Deutsch',
  es = 'Español',
  it = 'Italiano',
  no = 'Norsk',
  pt = 'Português',
  ru = 'Русский',
  nl = 'Nederlands',
  el = 'Ελληνικά',
  he = 'עִברִית',
  pl = 'Polski',
  ja = '日本語',
}
